export default (props, { emit }) => {
  const { modelValue: product } = props;

  const hasImage = product != null && product.image != null;

  const style = hasImage && {
    backgroundImage: `url(${product.image.source})`,
    backgroundSize: "auto",
  };

  return (
    hasImage && (
      <div className="c-modal c-modal--open">
        <div className="c-modal__image" style={style} onClick={() => emit("update:modelValue", null)}></div>
        <button type="button" className="c-modal__close" onClick={() => emit("update:modelValue", null)}></button>
      </div>
    )
  );
};
